import React, { Component } from 'react';
import $, { map } from 'jquery';

import AdminLayout from './../layout';

import LoadingSpinner from "./LoadingSpinner";

import { removeExclPtnrsEntry, getExclPtnrsEntry } from './../../../API/FetchCall';
//import { Editor } from '@tinymce/tinymce-react';


class exclusivePartnerDashboard extends Component {

    constructor(props) {
        super(props);
        this.state = {
          isreco:true,
          loading:true,
          list:[],
          auth_data: JSON.parse(localStorage.getItem("user_data")),
          user_data: localStorage.getItem('user_data') ? JSON.parse(localStorage.getItem('user_data')) : []
           
        };
    }

    componentDidMount() {

        const { user_data } = this.state;

        this.getEntry(user_data);


    }

    goEdit(id, optiontoshow){

      if(optiontoshow=='both')
        window.location='/exclusiveparnter/edit_excl/'+id;
      else if(optiontoshow=='onlyparents')
        window.location='/exclusiveparnter/edit_excl_parent/'+id;
      else if(optiontoshow=='onlypartners')  
        window.location='/exclusiveparnter/edit_excl_partner/'+id;

    }

    goRemove(id){

        if(confirm("You are sure you want to remove?")){

            const { user_data } = this.state;
            let req = JSON.stringify({
                id: id
            })

            removeExclPtnrsEntry(req).then(res => {

                if (res.status === 1) {
                
                  alert("Removed successfully");
                  window.location.reload();
                /*
                  let toastr = '';
                toastr = window.toastr.success;
                toastr('Partnership entry has now been removed', {
                  positionClass: "toast-bottom-right",
                  containerId: "toast-bottom-right"
                });
                */
                //this.setState({isreco:false});

                }

            });

        }

    }

    getEntry = (user_data) => {
        
        let req = JSON.stringify({
          login_id: user_data.login_id
        })
        getExclPtnrsEntry(req).then(res => {
          if (res.status === 1) {

            this.setState({loading:false});
            
            this.setState({list:res.results});

            /*
            this.setState({
              name: res.result.name,
              logo:res.result.logo,
              term:res.result.term,
              approved:res.result.approved,
              created_date:res.result.created_date,
              notes_seen:res.result.notes_seen,
              optiontoshow:res.result.optiontoshow,
              description:(res.result.description==null)?"":res.result.description
            })
            */
          }else{
            this.setState({loading:false});
            this.setState({isreco:false});
          }
        })
      }

    render() {

        const created_date = new Intl.DateTimeFormat('en-US', { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit' }).format(this.state.created_date)
        const isLoading = this.state.loading;

        return (
          <React.Fragment>
          <AdminLayout>
                    
 
                     
                                    {isLoading ? <LoadingSpinner /> :

                                    <div class="row mt-3">


                                      <div class="col-xl-6 d-flex grid-margin stretch-card">
                                        <div class="card">
                                         <div class="card-body">
                                              <h4 class="card-title mb-3">Exclusive Partnership Entries</h4>
      
                                              {this.state.list.map((item, i) => {

                                                 return <div class="entryrow">

                                                      {item.optiontoshow=='onlyparents' && (
                                                      <div class="smallnotesleft">You have created an entry for <strong>B2C</strong></div>
                                                      )} 

                                                      {item.optiontoshow=='onlypartners' && (
                                                      <div class="smallnotesleft">You have created an entry for <strong>B2B</strong></div>
                                                      )} 
                                                      {item.optiontoshow=='both' && (
                                                      <div class="smallnotesleft">You have created an entry for <strong>B2B and B2C</strong></div>
                                                      )} 

                                                      {(item.name=='' || item.name==null) && 
                                                        <div class="no_heading"><i>Name is empty, Please click 'Edit' to add</i></div>
                                                      }

                                                      {(item.name!='' || item.name!=null) && 
                                                       <div class="p_heading">{item.name}</div>
                                                      }
                                                      
                                                       

                                                      {item.optiontoshow=='both' && item.b2b_approved==0 &&
                                                      
                                                        <div class="approvalstatus waiting">B2B - waiting for approval</div>

                                                      }
                                                       {item.optiontoshow=='both' && item.b2b_approved==1 &&
                                                      
                                                      <div class="approvalstatus approved">B2B - Approved</div>

                                                      }    

                                                      {item.optiontoshow=='both' && item.b2c_approved==0 &&
                                                      
                                                        <div class="approvalstatus waiting">B2C - waiting for approval</div>

                                                      }
                                                       {item.optiontoshow=='both' && item.b2c_approved==1 &&
                                                      
                                                      <div class="approvalstatus approved">B2C - Approved</div>

                                                      }                                                       

                                                      {item.optiontoshow=='onlyparents' && item.approved==1 && ( 
                                                          <div>
                                                            <div class="blockstatus">
                                                                  <div class="approvalstatus approved">B2C - Approved</div>
                                                            </div>
                                                          </div>
                                                      )}
                                                       {item.optiontoshow=='onlyparents' && item.approved==0 && ( 
                                                          <div>
                                                            <div class="blockstatus">
                                                              <div class="approvalstatus waiting">B2C - waiting for approval</div>
                                                            </div>
                                                          </div>
                                                      )}

                                                      {item.optiontoshow=='onlypartners' && item.approved==1 && ( 
                                                          <div>
                                                            <div class="blockstatus">
                                                                  <div class="approvalstatus approved">B2B - Approved</div>
                                                            </div>
                                                          </div>
                                                      )}

                                                      {item.optiontoshow=='onlypartners' && item.approved==0 && ( 
                                                          <div>
                                                            <div class="blockstatus">
                                                            <div class="approvalstatus waiting">B2B - waiting for approval</div>
                                                            </div>
                                                          </div>
                                                      )}



                                                      {item.savedonly==1 && ( 
                                                          <div>
                                                            <div class="blockstatus">
                                                                  <div class="approvalstatus approved">Saved Only</div>
                                                            </div>
                                                          </div>
                                                      )}

                                                      {item.fresh==1 && (
                                                        
                                                          <div>
                                                            <div class="no_heading">
                                                                  <i>It is your fresh account, Please click Edit button to add more info onto your page</i>
                                                            </div>
                                                          </div>
                                                      )}   

                                                      {item.fresh==0 && item.savedonly==0 &&  item.approved==0 && (item.name!='' && item.name!=null) && (
                                                          <div class="approvalstatus waiting">Waiting for approval</div>
                                                      )}

                                                      {item.fresh==0 && item.savedonly==0 && item.approved==0 && (item.name=='' || item.name==null) && (
                                                          <div class="approvalstatus red">require more information for approval, Click 'Edit'</div>
                                                      )}

                                                      <div class="floatrightf">
                                                      <button class="btn btn-primary btn-sm" onClick={()=>this.goEdit(item.id, item.optiontoshow)}>Edit</button>&nbsp;
                                                      <button class="btn btn-primary btn-sm" onClick={()=>this.goRemove(item.id)}>Remove</button>
                                                      </div>

                                                      { item.optiontoshow == 'onlyparents' && (
                                                      <div style={{paddingTop:"30px"}}>
                                                      <p class="actionnote">Your page has been created for Parents. Click "Create" to add for partners, ignore if already created.</p>
                                                      <a href="/exclusiveparnter/create_excl_partner" className={"btn btn-primary btn-sm"}>Create B2B</a>
                                                      </div>
                                                      )}

                                                      { item.optiontoshow == 'onlypartners' && (
                                                      <div style={{paddingTop:"30px"}}>
                                                      <p class="actionnote">Your page has been created for Partners. Click "Create" to add for parents, ignore if already created.</p>
                                                      <a href="/exclusiveparnter/create_excl_parent" className={"btn btn-primary btn-sm"}>Create B2C</a>
                                                      </div>
                                                      )}

                                                 </div> 

                                                 
                                              }) } 

                                              {this.state.list.length==0 &&
                                              <div class="nodata">
                                                <div class="nodatainfo1">No Info to edit</div>
                                                <div class="nodatainfoblue"><b>Please click <i>CREATE</i> button on the left side section</b></div>
                                              </div>
                                              }
                                         </div>
                                        </div>    
                                      </div>
                                    

                                   
                                    { this.state.isreco == false && (

                                        <div class="col-md-6 desktoponly">
                                          <div class="card">
                                        <div class="card-body">
                                        
                                          <div class="card-title">Partnership</div>
                                          <div >
                                            <a href="/exclusiveparnter/create_excl" className={"btn btn-primary btn-sm"}>Create</a>
                                         </div>
                                         </div>
                                        </div>
                                        </div>
                                    )}

 

                                    </div>
                                     } 
                                     
                                       

             

                </AdminLayout>
            </React.Fragment>
        )
    }
}


export default exclusivePartnerDashboard;


// WEBPACK FOOTER //
// ./src/components/bewise/exclusiveparnter/dashboard.jsx